import { DocumentationPage } from './_article.jsx';
export default function GettingStartedPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}